import Vue from 'vue'
import VueRouter from 'vue-router'
//首页
import Home from '../pages/home/index.vue'/* 首页 */
import Mine from '../pages/mine/index.vue'/* 我的 */
import Choose from '../pages/choose/index.vue'/* 选妃 */
import List from '../pages/choose/list.vue'/* 选妃列表 */
import Profile from '../pages/choose/profile.vue'/* 选妃详情 */
import Video from '../pages/video/index.vue'/* 视频 */
import Game from '../pages/game/index.vue'/* 游戏 */
import Login from '../pages/login/index.vue'/* 登录 */
import Register from '../pages/login/register.vue'/* 注册 */
import ServiceOnline from '../pages/mine/ServiceOnline.vue'/* 客服列表 */
import ServicePage from '../pages/mine/ServicePage.vue'/* 客服详情界面 */
import Setting from '../pages/mine/Setting.vue'/* 设置 */
import Infomation from '../pages/mine/Infomation.vue'/* 基本信息 */
import IndexInfo from '../pages/mine/IndexInfo.vue'/* 菜单 */
import Setname from '../pages/mine/Setname.vue'/* 修改姓名 */
import Language from '../pages/mine/Language.vue'/* 语言选择 */
import Setsex from '../pages/mine/Setsex.vue'/* 修改姓名 */
import Recharge from '../pages/mine/Recharge.vue'/* 充值 */
import RechargeList from '../pages/mine/RechargeList.vue'/* 充值记录 */

import SetPayPassword from '../pages/mine/SetPayPassword.vue'/* 修改提现密码 */
import SetLoginPassword from '../pages/mine/SetLoginPassword.vue'/* 修改提现密码 */
import Lottery from '../pages/lottery/index.vue'/* 彩票详情 */
import PlayVideo  from '../pages/video/PlayVideo'/* 视频播放页面 */
import Setbank  from '../pages/mine/Setbank'/* 视频播放页面 */
import BindCard  from '../pages/mine/BindCard'/* 绑定银行卡界面 */
import Withdraw  from '../pages/mine/Withdraw'/* 绑定银行卡界面 */
import Personalreport  from '../pages/mine/Personalreport'/* 个人表报 */
import GameRecord  from '../pages/mine/GameRecord'/* 游戏记录 */
import WithdrawRecord  from '../pages/mine/WithdrawRecord'/* 提现记录 */
import Details from '../pages/home/girlsInfo'
import message from '../pages/notice/index.vue'
import lotteryHall from '../pages/lottery/lotteryHall.vue'/* 认证中心 */
import SetPassword from '../pages/mine/SetPassword.vue'
import ledger from '../pages/mine/ledger.vue'
import discuss from '../pages/lottery/discuss.vue'
import resultsDetails from '../pages/lottery/resultsDetails.vue'
import BindWallet from '../pages/mine/BindWallet.vue'/* 绑定钱包 */
import WithdrawWallet from '../pages/mine/WithdrawWallet.vue'/* 提现钱包 */

Vue.use(VueRouter)
const routes = [
    
	{path:'/',redirect:'/Home',component:Home,meta:{title:'Honey Badger Entertainment'}},
	{path:'/Home',name:'home',component:Home,meta:{title:'Honey Badger Entertainment'}},
	{path:'/Choose',name:'choose',component:Choose,meta:{title:'Honey Badger Entertainment'}},
	{path:'/List',name:'list',component:List,meta:{title:'Honey Badger Entertainment'}},
	{path:'/Profile',name:'profile',component:Profile,meta:{title:'Honey Badger Entertainment'}},
	{path:'/Mine',name:'mine',component:Mine,meta:{title:'Honey Badger Entertainment'}},
	{path:'/Video',name:'video',component:Video,meta:{title:'Honey Badger Entertainment'}},
	{path:'/Game',name:'game',component:Game,meta:{title:'Honey Badger Entertainment'}},
	{path:'/Login',name:'login',component:Login,meta:{title:'Honey Badger Entertainment'}},
	{path:'/Register',name:'register',component:Register,meta:{title:'Honey Badger Entertainment'}},
	{path:'/ServiceOnline',name:'ServiceOnline',component:ServiceOnline,meta:{title:'Honey Badger Entertainment'}},
	{path:'/ServicePage',name:'ServicePage',component:ServicePage,meta:{title:'Honey Badger Entertainment'}},
	{path:'/Setting',name:'Setting',component:Setting,meta:{title:'Honey Badger Entertainment'}},
	{path:'/Infomation',name:'Infomation',component:Infomation,meta:{title:'Honey Badger Entertainment'}},
	{path:'/IndexInfo',name:'IndexInfo',component:IndexInfo,meta:{title:'Honey Badger Entertainment'}},
	{path:'/Setname',name:'Setname',component:Setname,meta:{title:'Honey Badger Entertainment'}},
	{path:'/Setsex',name:'Setsex',component:Setsex,meta:{title:'Honey Badger Entertainment'}},
	{path:'/Language',name:'Language',component:Language,meta:{title:'Honey Badger Entertainment'}},
	{path:'/Recharge',name:'Recharge',component:Recharge,meta:{title:'Honey Badger Entertainment'}},
	{path:'/RechargeList',name:'RechargeList',component:RechargeList,meta:{title:'Honey Badger Entertainment'}},
	
	{path:'/SetPayPassword',name:'SetPayPassword',component:SetPayPassword,meta:{title:'Honey Badger Entertainment'}},
	{path:'/SetLoginPassword',name:'SetLoginPassword',component:SetLoginPassword,meta:{title:'Honey Badger Entertainment'}},
	{path:'/Lottery',name:'Lottery',component:Lottery,meta:{title:'Honey Badger Entertainment'}},
	{path:'/PlayVideo',name:'PlayVideo',component:PlayVideo,meta:{title:'Honey Badger Entertainment'}},
	{path:'/Setbank',name:'Setbank',component:Setbank,meta:{title:'Honey Badger Entertainment'}},
	{path:'/BindCard',name:'BindCard',component:BindCard,meta:{title:'Honey Badger Entertainment'}},
	{path:'/Withdraw',name:'Withdraw',component:Withdraw,meta:{title:'Honey Badger Entertainment'}},
	{path:'/Personalreport',name:'Personalreport',component:Personalreport,meta:{title:'Honey Badger Entertainment'}},
	{path:'/WithdrawRecord',name:'WithdrawRecord',component:WithdrawRecord,meta:{title:'Honey Badger Entertainment'}},
	{path:'/GameRecord',name:'GameRecord',component:GameRecord,meta:{title:'Honey Badger Entertainment'}},
	{path:'/detail',name:'Details',component:Details,meta:{title:'Honey Badger Entertainment'}},
	{path:'/message',name:'message',component:message,meta:{title:'Honey Badger Entertainment'}},
	{path:'/lotteryHall',name:'lotteryHall',component:lotteryHall,meta:{title:'Honey Badger Entertainment'}},
	{path:'/SetPassword',name:'SetPassword',component:SetPassword,meta:{title:'Honey Badger Entertainment'}},
	{path:'/ledger',name:'ledger',component:ledger,meta:{title:'Honey Badger Entertainment'}},
	{path:'/discuss',name:'discuss',component:discuss,meta:{title:'Honey Badger Entertainment'}},
	{path:'/resultsDetails',name:'resultsDetails',component:resultsDetails,meta:{title:'Honey Badger Entertainment'}},
	{path:'/BindWallet',name:'BindWallet',component:BindWallet,meta:{title:'Honey Badger Entertainment'}},
	{path:'/WithdrawWallet',name:'WithdrawWallet',component:WithdrawWallet,meta:{title:'Honey Badger Entertainment'}},

	//兜底路由：未匹配到的路径（如 /index、拼错的地址）统一跳回首页，避免空白页
	{path:'*',redirect:'/Home'}


];

//生成路由实例
const router = new VueRouter({
    routes
})
router.beforeEach((to,from,next) => {         //修改标题路由配置加上这个
    // 注意：to.matched 可能为空（访问了路由表里不存在的路径，如 /index），
    // 直接取 to.matched[0].meta 会报 "Cannot read properties of undefined (reading 'meta')"。
    // vue-router 3 中未匹配时 to.meta 为 {}，安全；取不到 title 时回退到默认标题。
    document.title = to.meta.title || 'Honey Badger Entertainment'
    next()
})

export default router